"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUnitSystem = void 0;
var IUnitSystem;
(function (IUnitSystem) {
    IUnitSystem["Standard"] = "standard";
    IUnitSystem["Metric"] = "metric";
})(IUnitSystem || (exports.IUnitSystem = IUnitSystem = {}));
//# sourceMappingURL=unit-system.js.map